// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.U1U8OBQ8ymeCBNy8CiQj {
  --primary-button-background: var(--orange);
  --primary-button-hover-background: var(--light-orange);
  --primary-button-inactive-background: var(--extra-light-orange);

  --secondary-button-color: var(--orange);
  --secondary-button-border-color: var(--orange);
  --secondary-button-text-color: var(--orange);
  --secondary-button-hover-color: var(--light-orange);

  --title-horizontal-rule-color: var(--orange);

  --primary-link-color: var(--orange);
  --teritiary-link-color: var(--orange);

  --secondary-font-color: var(--orange);

  --read-testimonials-button: var(--orange);
}
`, "",{"version":3,"sources":["webpack://./src/styles/variables-GCS.orange.module.css"],"names":[],"mappings":"AAAA;EACE,0CAA0C;EAC1C,sDAAsD;EACtD,+DAA+D;;EAE/D,uCAAuC;EACvC,8CAA8C;EAC9C,4CAA4C;EAC5C,mDAAmD;;EAEnD,4CAA4C;;EAE5C,mCAAmC;EACnC,qCAAqC;;EAErC,qCAAqC;;EAErC,yCAAyC;AAC3C","sourcesContent":[".root {\n  --primary-button-background: var(--orange);\n  --primary-button-hover-background: var(--light-orange);\n  --primary-button-inactive-background: var(--extra-light-orange);\n\n  --secondary-button-color: var(--orange);\n  --secondary-button-border-color: var(--orange);\n  --secondary-button-text-color: var(--orange);\n  --secondary-button-hover-color: var(--light-orange);\n\n  --title-horizontal-rule-color: var(--orange);\n\n  --primary-link-color: var(--orange);\n  --teritiary-link-color: var(--orange);\n\n  --secondary-font-color: var(--orange);\n\n  --read-testimonials-button: var(--orange);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `U1U8OBQ8ymeCBNy8CiQj`
};
export default ___CSS_LOADER_EXPORT___;
